import { useEffect, useState } from "react";

export interface PvcDraftState {
  voiceId?: string;
  voiceName?: string;
  language?: string;
  sampleIds?: string[];
}

const STORAGE_KEY = "pvc_draft_state";

export const usePvcDraftState = () => {
  const [draft, setDraft] = useState<PvcDraftState>({});

  useEffect(() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        setDraft(parsed);
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  }, []);

  const updateDraft = (next: PvcDraftState) => {
    setDraft(next);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  };

  const clearDraft = () => {
    setDraft({});
    localStorage.removeItem(STORAGE_KEY);
  };

  return { draft, updateDraft, clearDraft };
};
